module.exports = {"610425001":"城关街道","610425101":"史德镇","610425102":"西张堡镇","610425103":"阡东镇","610425104":"烽火镇","610425105":"烟霞镇","610425106":"赵镇","610425108":"叱干镇","610425109":"南坊镇","610425110":"石潭镇","610425111":"昭陵镇","610425112":"骏马镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610425.json
// module id = 2949
// module chunks = 0